
import React from 'react';

interface HeroQuoteAfterImageProps {
  statement: string;
  className?: string;
}

const HeroQuoteAfterImage: React.FC<HeroQuoteAfterImageProps> = ({ statement, className = "" }) => {
  const paragraphs = statement.split('\n').filter(p => p.trim() !== '');
  
  return (
    <div className="col-span-full mt-8 lg:mt-12 max-w-2xl mx-auto w-full">
      <blockquote className={`relative pl-6 py-5 pr-5 bg-joerg-50/60 border-l-4 border-primary/40 rounded-r-2xl ${className}`}>
        {paragraphs.map((paragraph, index) => (
          <p key={index} className={`${index < paragraphs.length - 1 ? "mb-2" : ""} text-left italic leading-relaxed`}>
            {paragraph}
          </p>
        ))}
      </blockquote>
    </div>
  );
};

export default HeroQuoteAfterImage;
